import { isEmpty } from 'lodash';
import { useRecoilValue } from 'recoil';

import { TDatabaseColumn } from '../../api/types';
import LoadingIndicator from '../../components/LoadingIndicator';
import TableChart from '../chart/components/TableChart';
import { PreviewQueryResultId } from './QueryBuilderHooks';
import {
  AFetchingPreview,
  APreviewTableTitle,
  SQueryResults,
} from './QueryState';

function PreviewData() {
  const queryResults = useRecoilValue(SQueryResults(PreviewQueryResultId));
  const previewTableTitle = useRecoilValue(APreviewTableTitle);
  const isFetchingPreview = useRecoilValue(AFetchingPreview);
  const columns = queryResults?.results?.metadata?.columns || [];
  const rows = queryResults?.results?.rows;

  if (isFetchingPreview) {
    return (
      <div className='w-full flex items-center justify-center p-20'>
        <div>
          <LoadingIndicator />
        </div>
      </div>
    );
  }

  if (!rows) {
    return <div className='w-100 ml-10 mt-10'>No Preview Data</div>;
  }

  return (
    <div>
      <div className='py-2 pl-4'>
        <b>{previewTableTitle}</b>
      </div>
      {!isEmpty(columns) && (
        <TableChart
          className='max-h-[90vh]'
          columns={columns.map((c: TDatabaseColumn) => c.name)}
          data={rows}
        />
      )}
    </div>
  );
}
export default PreviewData;